
export default {
  serverUrl: process.env.REACT_APP_SERVER_URL,
  serverImageUrl: process.env.REACT_APP_SERVER_IMAGE_URL,
  webSocketUrl: process.env.REACT_APP_WEB_SOKET_URL,

  pickDropServerUrl: process.env.REACT_APP_PICK_DROP_SERVER_URL,
  dispatcherWebSocketUrl: process.env.REACT_APP_DISPATCHER_WEB_SOKET_URL,
  adminEnv: process.env.REACT_APP_ENV,

  basicAuth: process.env.BASIC_AUTH_USER,
  basicAuthPass: process.env.BASIC_AUTH_PASS,


  recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  adminImage50kb: process.env.REACT_APP_IMAGE_FILE_SIZE_50_KB,
  adminImage100kb: process.env.REACT_APP_IMAGE_FILE_SIZE_100_KB,
  adminImage150kb: process.env.REACT_APP_IMAGE_FILE_SIZE_150_KB,
  adminImage200kb: process.env.REACT_APP_IMAGE_FILE_SIZE_200_KB

  // webSocketUrl: process.env.REACT_APP_WEB_SOKET_URL,
};
